module.exports = __webpack_public_path__ + "img/mortgages.07036e8.webp";